<template>
  <el-dialog fullscreen :visible="isShow" :modal="false" :show-close="false" custom-class="dialog-form">
    <div slot="title" class="dialog-title-container">
      <span class="title-label"><i class="el-icon-document"></i> 不良品出库表单</span>
      <i class="el-icon-error" @click="close"></i>
    </div>
    <el-row class="form-top-btns">
      <template v-if="role_name === '超级权限' || role_name === '软件管理'">
        <el-button v-if="!formStatus && formData.id !== '0'" type="primary" size="mini" plain round icon="em-icon-edit" @click="formStatus = !formStatus"> 编辑</el-button>
        <el-button v-if="formStatus && formData.id !== '0'" type="info" size="mini" plain round icon="em-icon-edit" @click="formStatus = !formStatus"> 取消编辑</el-button>
        <el-button v-if="formStatus" type="primary" size="mini" plain round icon="em-icon-save" @click="handerSave"> 提交保存</el-button>
      </template>
      <el-button type="danger" size="mini" plain round icon="el-icon-close" @click="close">关闭</el-button>
    </el-row>
    <div class="form-container">
      <el-form ref="form" :model="formData" size="mini" label-width="80px">
        <div class="form-main">
          <el-row>
            <el-col :span="6">
              <el-form-item label="出库日期" required>
                 <el-date-picker v-if="formStatus" value-format="yyyy-MM-dd HH:mm" type="datetime" size="mini" placeholder="选择日期" clearable v-model="formData.outstore_date"></el-date-picker>
                 <span v-else>{{formData.outstore_date}}</span>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="样本册" required>
                <el-autocomplete v-if="formStatus" style="width: 100%"
                    popper-class="my-autocomplete"
                    v-model="formData.product_name"
                    :fetch-suggestions="querySearchAsync"
                    placeholder="请输入内容"
                    @select="handleSelect"
                    @blur="handblur">
                  <i
                      class="el-icon-edit el-input__icon"
                      slot="suffix"
                      @click="handleIconClick">
                  </i>
                  <template slot-scope="{ item }">
                      <span>{{ item.name }}</span>
                  </template>
                </el-autocomplete>
                <span v-else>{{formData.product_name}}</span>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="出库单号">
                <el-input v-if="formStatus" placeholder="出库单号" v-model="formData.outstore_no" disabled></el-input>
                <span v-else>{{formData.outstore_no}}</span>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="备注">
                <el-input v-if="formStatus" placeholder="备注" v-model="formData.remark"></el-input>
                <span v-else>{{formData.remark}}</span>
              </el-form-item>
            </el-col>
          </el-row>
        </div>
        <div class="detail-header">
            <div class="detail-title"><i class="em-icon-th-list"></i> 不良品出库明细</div>
            <el-button v-if="formStatus" type="primary" size="mini" icon="el-icon-plus" round @click="addDetailhandler">添加出库明细</el-button>
        </div>
        <div class="el-table-container form-details" style="top: 66px;">
          <div style="height: 100%;">
            <el-table :data="formData.details" size="mini" height="100%" style="width: 100%; border:1px solid #d1d1d1;" border header-row-class-name="list-header-row" row-class-name="list-row">
              <el-table-column label="序号" type="index" width="47" align="center"></el-table-column>
              <el-table-column label="部品名称" prop="base_material_name" width="150" align="center"></el-table-column>
              <el-table-column label="台数" width="100" align="center">
                <template v-slot:default="scope">
                  <el-select :disabled="scope.row.base_material_name !== '台纸'" v-if="formStatus" size="mini" v-model="scope.row.table_number" placeholder="请选择" @change="tableNumberChange(scope.row)">
                    <el-option v-for="item in tableNumberArr" :key="item.value"  :label="item.value" :value="item.value"></el-option>
                  </el-select>
                  <span v-else>{{scope.row.table_number}}</span>
                </template>
              </el-table-column>
              <el-table-column label="页码" width="100" align="center">
                <template v-slot:default="scope">
                  <el-select :disabled="scope.row.base_material_name !== '台纸'" v-if="formStatus" size="mini" v-model="scope.row.page" placeholder="请选择">
                    <el-option v-for="item in scope.row.pageArr" :key="item.value"  :label="item.value" :value="item.value"></el-option>
                  </el-select>
                  <span v-else>{{scope.row.page}}</span>
                </template>
              </el-table-column>
              <el-table-column label="不良品数量" width="100" align="center">
                <template v-slot:default="scope">
                  <el-input size="mini" v-if="formStatus" placeholder="数量" class="txtC" v-model="scope.row.reject_number"></el-input>
                  <span v-else>{{scope.row.reject_number}}</span>
                </template>
              </el-table-column>
              <el-table-column label="备注" prop="remark" align="center">
                <template v-slot:default="scope">
                  <el-input size="mini" v-if="formStatus" placeholder="备注" v-model="scope.row.remark"></el-input>
                  <span v-else>{{scope.row.remark}}</span>
                </template>
              </el-table-column>
              <el-table-column label="操作" width="50" align="center">
                <template v-slot:default="scope">
                  <el-button v-if="formStatus" type="danger" size="mini" icon="el-icon-minus" circle @click.stop.prevent="handlerDelDetails(scope.$index)"></el-button>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </div>
        <div class="form-footer">
          <span>制单人：{{formData.creater_name}}</span>
          <span>制单日期：{{formData.create_time.substring(0,10)}}</span>
        </div>
      </el-form>
    </div>
    <!-- 选择部件对话框 -->
    <ezz-dialog-product-part ref="productPartDialog" width="500px" :parent="this"></ezz-dialog-product-part>
  </el-dialog>
</template>
<script>
import EzzDialogProductPart from '@/views/modules/store/outreject/DialogPart.vue'
export default {
  name: 'EzzDialogForm',
  props: {
    parent: {
      type: Object,
      default: () => null
    }
  },
  data: function () {
    return {
      // 当前子组件对话框的显隐
      isShow: false,
      formData: null,
      formEmptyData: {
        id: '0',
        outstore_date: '',
        product_id: '',
        product_name: '',
        outstore_no: '',
        type: '',
        remark: '',
        details: [],
        creater_name: sessionStorage.getItem('operator'),
        creater_id: sessionStorage.getItem('operator_id'),
        create_time: ''
      },
      formDetailEmptyData: {
        id: '',
        product_id: '',
        base_material_id: '',
        base_material_name: '',
        table_number: '',
        page: '',
        pages: '',
        pageArr: [],
        reject_number: '0',
        remark: ''
      },
      productList: [],
      product_check: '',
      tableNumberArr: [],
      operator_id: sessionStorage.getItem('operator_id'),
      formStatus: false,
      editable: this.$store.state.editable,
      delable: this.$store.state.delable,
      role_name: sessionStorage.getItem('role_name')
    }
  },
  beforeCreate: function () {
    var date = new Date()
    var month = date.getMonth() < 9 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1
    var day = date.getDate() <= 9 ? '0' + date.getDate() : date.getDate()
    var hours = date.getHours() <= 9 ? '0' + date.getHours() : date.getHours()
    var mins = date.getMinutes() <= 9 ? '0' + date.getMinutes() : date.getMinutes()
    this.currentDate = date.getFullYear() + '-' + month + '-' + day
    this.currentTime = date.getFullYear() + '-' + month + '-' + day + ' ' + hours + ':' + mins
  },
  created: function () {
    this.formData = JSON.parse(JSON.stringify(this.formEmptyData))
  },
  mounted: function () {
  },
  methods: {
    // 样本册搜索
    loadProduct: function () {
      let _this = this
      _this.get(_this.$apis.getInstoreProduct, {}, function (res) {
        _this.productList = res.data.dataList
      })
    },
    querySearchAsync: function (queryString, cb) {
      this.product_check = 'false'
      var results = queryString ? this.productList.filter(this.createStateFilter(queryString)) : this.productList

      clearTimeout(this.timeout)
      this.timeout = setTimeout(() => {
        cb(results)
      }, 500 * Math.random())
    },
    createStateFilter: function (queryString) {
      return (product) => {
        return product.name.indexOf(queryString) > -1
      }
    },
    handleSelect: function (item) {
      let _this = this
      _this.product_check = 'true'
      _this.formData.product_name = item.name
      _this.formData.product_id = item.id
      _this.tableNumberArr = []
      _this.formData.details = []
      // 获取样本册对应台数
      _this.post(_this.$apis.getProductTable, { ProductId: _this.formData.product_id }, function (res) {
        let _json = res.data
        if (_json.status && _json.status === 'logout') {
          _this.logout()
        } else {
          for (let i = 0; i < _json.tables.length; i++) {
            _this.tableNumberArr.push({ 'value': _json.tables[i] })
          }
        }
      })
    },
    handleIconClick: function (ev) {
      console.log(ev)
    },
    handblur: function () {
      if (this.product_check === 'false') {
        this.formData.product_name = ''
      }
    },
    // 加载外协单数据
    loadData: function () {
      let _this = this
      _this.post(_this.$apis.getOutStoreForm, { OutsotreId: _this.formData.id }, function (res) {
        let _json = res.data
        if (_json.status && _json.status === 'logout') {
          _this.logout()
        } else {
          if (_json.formData != null) {
            _this.formData = _json.formData
            if (_json.tables !== null) {
              _this.tableNumberArr = []
              for (let i = 0; i < _json.tables.length; i++) {
                _this.tableNumberArr.push({ 'value': _json.tables[i] })
              }
            }
            if (_this.formData.details !== null) {
              for (let j = 0; j < _this.formData.details.length; j++) {
                if (_this.formData.details[j].pages !== null) {
                  let pages = _this.formData.details[j].pages.split(',')
                  _this.formData.details[j].pageArr = []
                  for (let i = 0; i < pages.length; i++) {
                    _this.formData.details[j].pageArr.push({ 'value': pages[i] })
                  }
                }
              }
            }
          } else {
            _this.formData = JSON.parse(JSON.stringify(_this.formEmptyData))
            _this.formData.creater_id = _this.operator_id
            _this.formData.create_time = _this.currentDate
            _this.formData.outstore_date = _this.currentTime
          }
        }
      })
    },
    close: function () {
      this.$confirm('确定关闭？', '提示', {})
        .then(_ => {
          this.isShow = false
        })
        .catch(_ => {
          return false
        })
    },
    addHandler: function () {
      this.formData.id = '0'
      this.loadProduct()
      this.loadData()
      this.isShow = true
      this.formStatus = true
    },
    viewHandler: function (formId) {
      this.formData.id = formId
      this.loadProduct()
      this.loadData()
      this.isShow = true
      this.formStatus = false
    },
    // 添加明细
    addDetailhandler: function () {
      if (this.formData.product_name === '') {
        this.$message({
          type: 'error',
          message: '请先选择样本册'
        })
        return
      }
      this.$refs.productPartDialog.open()
    },
    // 台数改变事件
    tableNumberChange: function (item) {
      let _this = this
      item.page = ''
      item.pageArr = []
      _this.post(_this.$apis.getProductPage, { ProductId: _this.formData.product_id, tableNumber: item.table_number }, function (res) {
        let _json = res.data
        if (_json.status && _json.status === 'logout') {
          _this.logout()
        } else {
          let pages = _json.pages.split(',')
          for (let i = 0; i < pages.length; i++) {
            item.pageArr.push({ 'value': pages[i] })
          }
        }
      })
    },
    handlerDelDetails: function (_index) {
      const _this = this
      _this.$confirm('确定删除?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        _this.$delete(_this.formData.details, _index)
      }).catch(() => {
        _this.$message({
          type: 'info',
          message: '已取消删除'
        })
      })
    },
    // 表单验证，_mainData是主表数据，_detailData从表数据，如果只验证从表数据，_mainData要设置为null
    validationHandler: function (_mainData) {
      let _this = this
      if (_mainData !== null) {
        if (_mainData.outstore_date === '') {
          _this.$message({
            type: 'error',
            message: '出库日期不能为空'
          })
          return false
        }

        if (_mainData.product_name === '') {
          _this.$message({
            type: 'error',
            message: '样本册不能为空'
          })
          return false
        }

        if (_mainData.details.length === 0) {
          _this.$message({
            type: 'error',
            message: '出库明细不能为空'
          })
          return false
        }
      }
      return true
    },
    // 新增时主从表同时保存
    handerSave: function () {
      let _this = this
      if (_this.validationHandler(_this.formData)) {
        _this.formData.operator_id = _this.operator_id
        _this.formData.type = '2'
        _this.post(_this.$apis.saveOutreject, _this.formData, function (res) {
          let _json = res.data
          if (_json.status && _json.status === 'logout') {
            _this.logout()
          } else {
            if (_json.status === 'ok') {
              _this.$message({
                message: '保存成功',
                type: 'success'
              })
              _this.viewHandler(_json.id)
              _this.parent.loadData()
            }
          }
        })
      }
    }
  },
  components: {
    EzzDialogProductPart
  }
}
</script>
